
(function profileModuleDefinition() {

    'use strict';

    angular.module('Profile', ['Auth', 'AuthExtend', 'Language', 'ui.router', 'Config', 'EqualsValidation', 'ErrorsExtend', 'UnitOrgControl', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider','loginProvider',
            function profileConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('profile', {
                    url: "/profile?mail",
                    templateUrl: config.resourceUrl('/views/profile/profile.html'),
                    controller: 'ProfileController',
                    authorize: true
                });
                
                $stateProvider.state('change-password', {
                    url: "/Profile/ChangePassword",
                    templateUrl: config.resourceUrl('/views/profile/change-password.html'),
                    controller: 'ChangePasswordController',
                    authorize: true
                });

                $stateProvider.state('user-impersonation', {
                    url: "/Profile/Impersonation",
                    templateUrl: config.resourceUrl('/views/profile/user-impersonation.html'),
                    controller: 'UserImpersonationController',
                    authorize: true,
                    roles: loginProvider.roleCondition('USERIMPERSONATION WRITE')

                });

                $stateProvider.state('edit-profile', {
                    url: "/Profile/EditProfile",
                    templateUrl: config.resourceUrl('/views/profile/edit-profile.html'),
                    controller: 'EditProfileController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PROFILE MODIFY')
                });

                $stateProvider.state('profile-detail', {
                    url: "/Profile/ProfileDetail",
                    templateUrl: config.resourceUrl('/views/profile/profile-detail.html'),
                    controller: 'ProfileDetailController',
                    authorize: true
                });

            }
        ]);
})();